import React, { useContext, useReducer, useRef, useState } from 'react'
import { GoogleMap } from '../../utils/googlemaps';
import gifAlerta from '../../assets/images/gifalertaNueva.gif'
import { UserContext } from '../../context/provider/UserProvider';
import { AuthFetch } from '../../services/api';
import { notify } from '../../utils/utils';

const urlPlaminApi = process.env.REACT_APP_PLAMIN_API + '/api';
const urlPlaminVehicleApi = 'https://plaminwebvehiclelocalizator-webapi.abexacloud.com/api' 
// const URL = 'http://localhost:5240/api' 

export const useIncidentes = () => {
    const marcadorAlerta = useRef(null)
    const marcadorPolicia = useRef(null)
    const marcadorUnidad = useRef(null)
    const marcadorGifAlerta = useRef(null)
    

    const incidentesInicial = {
        incidentes: [],
        incidente: null,
        estadoActual: 9,
        googleMap: new GoogleMap()
    }
    const incidentesTipo = {
        LISTAR_INCIDENTES: 'LISTAR_INCIDENTES',
        OBTENER_INCIDENTE: 'OBTENER_INCIDENTE',
        CAMBIAR_ESTADO: 'CAMBIAR_ESTADO',
    }

    const [jurisdiccionMapa,setJurisdiccionMapa] = useState('')
    const [agentesTotales,setAgentesTotales] = useState([])
    const [positionNuevaIncidencia,setPositionNuevaIncidencia] = useState({})
    const [recorridoAlertaPanico, setRecorridoAlertaPanico]= useState([])

    const incidentesReducer = (state, action) => {
        switch (action.type) {
            case incidentesTipo.LISTAR_INCIDENTES:
                return {
                    ...state,
                    incidentes: action.payload
                }
            case incidentesTipo.OBTENER_INCIDENTE:
                return {
                    ...state,
                    incidente: action.payload
                }
            case incidentesTipo.CAMBIAR_ESTADO:
                return {
                    ...state,
                    estadoActual: action.payload.codEstado
                }
            default:
                throw new Error(`Invalid action type`);
        }
    }

    const [ stateIncidentes, dispatchIncidentes ] = useReducer(incidentesReducer, incidentesInicial);
    const {stateUser} = useContext(UserContext)

    const listarIncidentes = async (codEstado) => {
        const response = await AuthFetch({
            url: urlPlaminApi + '/alerts?' + new URLSearchParams({
                CodEstado: 0,
            })
        });

        if (response.isValid) {
            dispatchIncidentes({ type: incidentesTipo.LISTAR_INCIDENTES, payload: response.content });
        }

        dispatchIncidentes({ type: incidentesTipo.CAMBIAR_ESTADO, payload: { codEstado: codEstado || 0 } });
    }

    const  listarIncidenciasTemp = async (codEstado) => {
        const response = await AuthFetch({
            url: urlPlaminApi + '/alerts?' + new URLSearchParams({
                CodEstado: 0,
            })
        });

        return response.isValid ? response.content : []
        // setIncidencias(response.isValid ? response.content : [])
    }
    
    const ubicarIncidencia = async (incidencia, esNuevaIncidencia, renderContent) => {
        !esNuevaIncidencia && stateIncidentes.googleMap.quitarTodosLosMarcadores()

        marcadorAlerta.current = stateIncidentes.googleMap.crearMarcador({
            animation: esNuevaIncidencia ? true : false,    //la animacion solo cuando es una incidencia reciente
            visible: false,
        });

        // stateIncidentes.googleMap.crearMarcadorGif({
        //     icon: gifAlerta,
        //     latLng: {lat: incidencia.latitudRegistro || incidencia.latitud || incidencia.latitudAlerta, lng: incidencia.longitudRegistro || incidencia.longitud || incidencia.longitudAlerta}
        // })
        
        marcadorGifAlerta.current = stateIncidentes.googleMap.crearMarcadorGif({
            icon: gifAlerta,
            latLng: {lat: incidencia.latitudRegistro || incidencia.latitud || incidencia.latitudAlerta, lng: incidencia.longitudRegistro || incidencia.longitud || incidencia.longitudAlerta}
        })

        marcadorAlerta.current.setOptions({
            position: {lat: incidencia.latitudRegistro || incidencia.latitud || incidencia.latitudAlerta, lng: incidencia.longitudRegistro || incidencia.longitud || incidencia.longitudAlerta},
            visible: true
        })

        if(esNuevaIncidencia){
            setPositionNuevaIncidencia({
                lat: incidencia.latitud || incidencia.latitudAlerta,
                lng: incidencia.longitud  || incidencia.longitudAlerta
            })
        }else{
            setPositionNuevaIncidencia({})
        }

        // marcadorAlerta.current = stateIncidentes.googleMap.marcadores[0]

        stateIncidentes.googleMap.map.setOptions({
            center: {lat: incidencia.latitudRegistro || incidencia.latitud || incidencia.latitudAlerta , lng: incidencia.longitudRegistro || incidencia.longitud || incidencia.longitudAlerta},
            zoom: 15
        })
    }

    const seguimientoVehiculo = async (companyCode, unitCode) => {
        try{
            const response = await fetch(urlPlaminVehicleApi + '/follow_vehicle?' +
                new URLSearchParams({companyCode: companyCode , unitCode: unitCode}),
                {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'}
                }
            )//.then(res => res.json())
        }
        catch(e){
            console.error('Ocurrió un erro al ejecutar SeguimientoVehiculo → ',e)
        }
    }

    const obtenerJurisdiccionPoligono = async () => {
        const response = await AuthFetch({
            url: urlPlaminApi + '/Entities/jurisdictionByEntity?' + new URLSearchParams({
                codEntidad: stateUser.codEntidad || 0
            })
        });
        if(response.content.length > 0)
        {
            const path = response.content[0].poligonoJurisdiccion.split(',').map(latLng => {
                const [ lat, lng ] = latLng.split(';');
                return { lat: Number(lat), lng: Number(lng) };
            })
    
            const poligonoCreado = stateIncidentes.googleMap.crearPoligono({listLatLng: path , opacidadFondo: 0});
            setJurisdiccionMapa(poligonoCreado)
        }    
    }

    const obtenerUbicacionAgentes = async (codAlerta = null) => {
        const parametros = {
            codEntidad : stateUser.codEntidad || 0
        }
        codAlerta && (parametros.codAlerta = codAlerta)
        const response = await AuthFetch({
            url: urlPlaminApi + '/User/agentsTotal?' + new URLSearchParams(parametros),
        })

        if(response.isValid) {
            return response.content
        }else {
            return []
        }
    }

    const obtenerUbicacionAgentesPorAlerta = async (codAlerta) => {
        const response = await AuthFetch({
            url: urlPlaminApi + '/User/agentsTotal?' + new URLSearchParams({
                codEntidad: stateUser.codEntidad,
                codAlerta: codAlerta,
            })
        })

        if(response.isValid){
            setAgentesTotales(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const toUTCISO = (fecha) => {
        const [dd, mm, yyyy, hh, min, ss] = fecha.match(/\d+/g);
        // Creamos la fecha asumiendo que es hora local de Lima (UTC-5)
        const date = new Date(Date.UTC(yyyy, mm-1, dd, hh, min, ss));
        date.setHours(date.getHours()); // sumamos las 5 horas de diferencia
        
        return date.toISOString();
    }

    const registrarAlertaPanico = async (alerta) => {
        try{
            const response = await AuthFetch({
                url: urlPlaminApi + '/Alerts/generateEmergencyGPS?',
                method: "POST",
                body: JSON.stringify({
                    "codAlertaTipo": alerta.codAlertaTipo,
                    "mensajeAlerta": alerta.mensajeAlerta,
                    "latitudAlerta": alerta.latitudAlerta,
                    "longitudAlerta": alerta.longitudAlerta,
                    "fechaHoraAlerta": toUTCISO(alerta.fechaHoraAlerta),
                    "nomAlertaArchivo": "",
                    "latitudAlertaArchivo": 0,
                    "longitudAlertaArchivo": 0,
                    "fechaHoraAlertaArchivo": toUTCISO(alerta.fechaHoraAlerta),
                    "concatenadoCongresistas": "",
                    "telefono": alerta.telefono || "",
                    "nroDocumento": "",
                    "usuarioIncognito": true,
                    "direccion": "",
                    "codEmpresa": alerta.codEmpresa,
                    "codUnidad": alerta.codUnidad
                })
            });
        }
        catch(e){
            console.error('Error al guardar alerta pánico →', e)
        }
    }

    const listarRecorridoAlertaPanico = async (codEmpresa, fechaHoraInicio, fechaHoraFin, codUnidad) => {
        try{
            const response = await AuthFetch({
                url: urlPlaminApi + '/Alerts/lineaRuta?' + new URLSearchParams({
                    CodEmpresa: codEmpresa,
                    FechaInicio: fechaHoraInicio,
                    FechaFin: fechaHoraFin,
                    CodUnidad: codUnidad,
                }),
                method: "GET"
            })
            setRecorridoAlertaPanico(response.isValid ? response.content : [])
        }
        catch(e){
            console.error('Error al listar recorrido alerta panico → ',e)
            setRecorridoAlertaPanico([])
        }
    }
    
    const limpiarMarcadorUnidad = () => {
        if(marcadorUnidad.current) {
            stateIncidentes.googleMap.quitarMarcadorEspecifico(marcadorUnidad.current);
            marcadorUnidad.current = null;
        }
    }

    return {
        stateIncidentes,
        dispatchIncidentes,
        listarIncidentes,
        ubicarIncidencia,
        stateUser,
        positionNuevaIncidencia,
        marcadorAlerta,
        marcadorPolicia,
        obtenerJurisdiccionPoligono,
        jurisdiccionMapa,
        obtenerUbicacionAgentes,
        obtenerUbicacionAgentesPorAlerta,
        agentesTotales,
        listarIncidenciasTemp,
        registrarAlertaPanico,
        marcadorUnidad,
        seguimientoVehiculo,
        limpiarMarcadorUnidad,
        listarRecorridoAlertaPanico,
        recorridoAlertaPanico,
        marcadorGifAlerta,
    };
};
